import { Component } from '@theme/component';
import { mediaQueryLarge } from '@theme/utilities';

class ProductDetailsSticky extends Component {
  /** @type {number} */
  #lastScrollY = 0;

  /** @type {number} */
  #stickyTop = 0;

  /** @type {number} */
  #scrollDelta = 0;

  /** @type {AbortController | null} */
  #abortController = null;

  /** @type {ResizeObserver | null} */
  #resizeObserver = null;

  connectedCallback() {
    super.connectedCallback();

    if (!mediaQueryLarge.matches) return;

    this.#lastScrollY = window.scrollY;
    this.#stickyTop = 0;
    this.#scrollDelta = 0;

    this.#calculateScrollDelta();

    this.#abortController?.abort();
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;

    window.addEventListener('scroll', this.#handleScroll, { passive: true, signal });

    this.#resizeObserver?.disconnect();
    this.#resizeObserver = new ResizeObserver(this.#calculateScrollDelta);
    this.#resizeObserver.observe(this.#getContentElement());
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController?.abort();
    this.#abortController = null;

    this.#resizeObserver?.disconnect();
    this.#resizeObserver = null;

    this.style.removeProperty('--sticky-top');
  }

  /** @returns {Element} */
  #getContentElement() {
    return this.querySelector('.product-details__inner') ?? this;
  }

  #calculateScrollDelta = () => {
    const contentHeight = this.#getContentElement().scrollHeight;
    const availableHeight = window.innerHeight;

    this.#scrollDelta = Math.max(0, contentHeight - availableHeight);
  };

  #handleScroll = () => {
    this.#calculateScrollDelta();

    if (this.#scrollDelta === 0) {
      this.#lastScrollY = window.scrollY;
      return;
    }

    const scrollTop = Math.max(window.scrollY, 0);
    const delta = scrollTop - this.#lastScrollY;

    this.#stickyTop = Math.max(-this.#scrollDelta, Math.min(0, this.#stickyTop - delta));
    this.style.setProperty('--sticky-top', `${this.#stickyTop}px`);
    this.#lastScrollY = scrollTop;
  };
}

if (!customElements.get('product-details-sticky')) {
  customElements.define('product-details-sticky', ProductDetailsSticky);
}
